import React, { useState, useCallback } from 'react';
import cx from 'classnames';
import { FormTitle } from '../../FormTitle/FormTitle';
import { Form } from '../Form';
import { ButtonContainer } from '../../../Button/Button';
import { Input } from '../../../Input/Input';
import s from './StepThree.module.css';
import sg from '../../../../../../styles/index.module.css';
import { isValidCodeFormat, validateCode, CODE_LENGTH } from '../../../validate';
import { Timer } from '../../Timer';

export const StepThree = ({
    state,
    sendConfirmationCode,
    updateCode,
    serverErrors,
    setServerErrors,
    sendPhoneForSendOneTimeCode,
    setToken,
    setStep,
}) => {
    const [errors, setErrors] = useState({
        code: null,
    });

    const [isTimerStart, setIsTimerStart] = useState(true);
    const isButtonDisabled =
        !!Object.values(errors).filter((item) => !!item).length ||
        !!serverErrors.code ||
        state.code.length !== CODE_LENGTH;
    const subtitle = () => (
        <span>
            {i18next.t('StepThree.return.subtitle.part1')}{' '}
            <span
                className={cx(s.phoneNumber, { [sg.textEllipsis]: state.phoneNumber.length > 15 })}
            >
                {state.phoneNumber}
            </span>
            . {i18next.t('StepThree.return.subtitle.part2')}
        </span>
    );
    const endTimer = useCallback(() => {
        setIsTimerStart(false);
    }, []);

    return (
        <div>
            <FormTitle
                title={i18next.t('StepThree.return.FormTitle.title')}
                subtitle={subtitle()}
            />
            <Form>
                <Input
                    type="text"
                    error={!!errors.code || !!serverErrors.code}
                    helperText={(errors.code || serverErrors.code) ?? ' '}
                    value={state.code}
                    autoFocus
                    onChange={(e) => {
                        if (isValidCodeFormat(e.target.value)) {
                            updateCode(e.target.value);
                        }
                        setErrors((prevState) => ({ ...prevState, code: null }));
                        setServerErrors((prevState) => ({ ...prevState, code: null }));
                    }}
                    onBlur={(e) => {
                        const error = validateCode(e.target.value);
                        if (error) {
                            setErrors((prevState) => ({ ...prevState, code: error }));
                        }
                    }}
                    inputProps={{
                        'data-id': 'register-code',
                    }}
                />
                <div className={s.buttonBlock}>
                    <div className={s.buttonWrapper}>
                        <ButtonContainer
                            textButton={i18next.t('StepThree.return.ButtonContainer.textButton')}
                            disable={isButtonDisabled}
                            onClick={sendConfirmationCode}
                            needShowLoader={state.needShowLoader}
                        />
                    </div>
                    {isTimerStart && (
                        <div className={s.codeTextWrapper}>
                            <span>{i18next.t('StepThree.return.codeTextWrapper.span')}</span>{' '}
                            <Timer timer={60} endTimer={endTimer} />{' '}
                            <span>{i18next.t('StepThree.return.codeTextWrapper.second')}</span>
                        </div>
                    )}
                    {!isTimerStart && (
                        <div
                            className={s.resendCode}
                            onClick={() => {
                                setIsTimerStart(true);
                                setToken('');
                                setStep(1);
                                // sendPhoneForSendOneTimeCode();
                            }}
                            data-id="register-resend-code-request"
                        >
                            {i18next.t('StepThree.return.resendCode.text')}
                        </div>
                    )}
                </div>
            </Form>
        </div>
    );
};
